import classnames from "classnames";
import React, { type FC } from "react";
import { type WithTranslation, withTranslation } from "react-i18next";
import { isVendorCentral } from "src/api/config";
import Avatar from "src/components/AICLayout/AICHeader/Avatar";
import LocationSelector from "src/components/AICLayout/AICHeader/LocationSelector/LocationSelector";
import PortalLogo from "src/components/AICLayout/AICHeader/PortalLogo";
import { getUsernameFromCookie, isMidwayCookieSet } from "src/cookies";

import styles from "../../../styles.module.scss";
import NestNavBar from "./NestNavBar";

const AICHeader: FC<AICHeaderProps & WithTranslation> = ({
  disableCountryChange,
  fixedCountry,
  disableUrlSearchParamsUpdate,
  isNest,
}) => {
  const userName = getUsernameFromCookie();
  const isEmbeddedInVendorCentral = isVendorCentral();
  return (
    <div
      className={classnames(
        styles.min_w_100,
        styles.z_index_max,
        styles.box_shadow,
        styles.padding_header,
        styles.bg_color_squid_ink_800,
        { [styles.mt_neg_30]: isEmbeddedInVendorCentral }
      )}
    >
      <div
        className={classnames(
          styles.display_flex,
          styles.flex_direction_row,
          styles.justify_space_between,
          styles.items_center,
          styles.w_100
        )}
      >
        <div className={classnames(styles.flex)}>
          <PortalLogo />
        </div>
        <div
          className={classnames(
            styles.display_flex,
            styles.flex_direction_row,
            styles.justify_end
          )}
        >
          <div
            className={classnames(
              styles.flex,
              styles.align_items_center,
              styles.pr_1_rem,
              styles.pl_1_rem
            )}
          >
            <NestNavBar isNest={isNest} />
            <LocationSelector
              disableCountryChange={disableCountryChange}
              fixedCountry={fixedCountry}
              disableUrlSearchParamsUpdate={disableUrlSearchParamsUpdate}
            />
          </div>
          {isMidwayCookieSet() && (
            <>
              <div
                className={classnames(
                  styles.flex,
                  styles.pr_1_rem,
                  styles.pl_1_rem
                )}
              >
                <Avatar userAlias={userName} />
              </div>
              <div
                className={classnames(
                  styles.flex,
                  styles.pl_1_rem,
                  styles.pr_1_rem
                )}
              >
                <div
                  className={classnames(
                    styles.justify_end,
                    styles.flex,
                    styles.align_items_center
                  )}
                ></div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export interface AICHeaderProps {
  disableCountryChange?: boolean;
  fixedCountry?: string;
  disableUrlSearchParamsUpdate?: boolean;
  isNest?: boolean;
}

export default withTranslation()(AICHeader);
